import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../../client';
import { getScenes, setScenes } from '../../services/smartthermostat/ScenesService';

export const useScenesGetScenes = createDCHook('getScenes', collapseDataFromCall(getScenes), {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: true,
});

export const useScenesSetScenes = createMutationHook(
  collapseParams(collapseParams(setScenes, 'requestBody', 'data'), 'data', 'temperature'),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['temperature'] },
    ],
  },
);
